function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
// import Member from "./Member.js";
// import TeamHead from "./TeamHead.js";
// import Admin from "./AdminControl.js";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import "./AccessControl.css";
var FeatureList = [{
  feature: "Access real-time data",
  admin: true,
  teamHead: false,
  member: false
}, {
  feature: "View Screenshots",
  admin: true,
  teamHead: false,
  member: false
}, {
  feature: "View and Edit Projects and Tasks",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Review Time and Attendance",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "View Apps and Websites Usage",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Label Apps and Websites",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Manage Organisation",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Manage Billing",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Add Teams",
  admin: true,
  teamHead: false,
  member: true
}, {
  feature: "Invite Employeess",
  admin: true,
  teamHead: false,
  member: true
}];
var AccessControl = function AccessControl() {
  return /*#__PURE__*/React.createElement("div", {
    className: "access-control-content"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "access-control-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "access-control-thead"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Feature"), /*#__PURE__*/React.createElement("th", {
    className: "access-control-checkbox-th"
  }, "Admin"), /*#__PURE__*/React.createElement("th", {
    className: "access-control-checkbox-th"
  }, "Team Head"), /*#__PURE__*/React.createElement("th", {
    className: "access-control-checkbox-th"
  }, "Member"))), /*#__PURE__*/React.createElement("tbody", {
    className: "access-control-tbody"
  }, FeatureList.map(function (FeatureListData) {
    return /*#__PURE__*/React.createElement(FeatureData, {
      FeatureListData: FeatureListData
    });
  }))));
};
var FeatureData = function FeatureData(props) {
  var FeatureListData = props.FeatureListData;
  var _React$useState = React.useState(FeatureListData.admin),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    adminActive = _React$useState2[0],
    setAdminActive = _React$useState2[1];
  var _React$useState3 = React.useState(FeatureListData.teamHead),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    teamHeadActive = _React$useState4[0],
    setTeamHeadActive = _React$useState4[1];
  var _React$useState5 = React.useState(FeatureListData.member),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    memberActive = _React$useState6[0],
    setMemberActive = _React$useState6[1];
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, FeatureListData.feature), /*#__PURE__*/React.createElement("td", {
    className: "access-control-checkbox-td"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    custom: true,
    inline: true,
    label: "",
    type: "checkbox",
    id: "custom-inline-checkbox-admin-".concat(FeatureListData.feature.split(" ").join("-")),
    className: "access-control-checkbox",
    checked: adminActive,
    onChange: function onChange() {
      return setAdminActive(adminActive == true ? false : true);
    }
  }))), /*#__PURE__*/React.createElement("td", {
    className: "access-control-checkbox-td"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    custom: true,
    inline: true,
    label: "",
    type: "checkbox",
    id: "custom-inline-checkbox-team-head-".concat(FeatureListData.feature.split(" ").join("-")),
    className: "access-control-checkbox",
    checked: teamHeadActive,
    onChange: function onChange() {
      return setTeamHeadActive(teamHeadActive == true ? false : true);
    }
  }))), /*#__PURE__*/React.createElement("td", {
    className: "access-control-checkbox-td"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    custom: true,
    inline: true,
    label: "",
    type: "checkbox",
    id: "custom-inline-checkbox-member-".concat(FeatureListData.feature.split(" ").join("-")),
    className: "access-control-checkbox",
    checked: memberActive,
    onChange: function onChange() {
      return setMemberActive(memberActive == true ? false : true);
    }
  }))));
};
export default AccessControl;